import { render, staticRenderFns } from "./ApprovalRequestListItem.vue?vue&type=template&id=e53bacb8"
import script from "./ApprovalRequestListItem.vue?vue&type=script&lang=js"
export * from "./ApprovalRequestListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports